const Checkmark = (props: React.HTMLAttributes<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="8"
      fill="none"
      data-testid="checkmark-icon"
      {...props}
    >
      <path
        d="M10.667.792 4.25 7.208 1.333 4.292"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { Checkmark };
